function mySort (a, b) {
    return a.sort > b.sort ? 1 : -1
}

function setPath (arr, path) {
    for (let i = 0; i < arr.length - 1; i++) {
        path.push({
            from: arr[i].name,
            to: arr[i + 1].name
        })
    }
}

export default function (points) {
    if (!points.length) return []
    const path = []

    const toPathPoints = points.filter(point => !point.direction)
        .sort(mySort)
    const fromPathPoints = points.filter(point => point.direction)
        .sort(mySort)

    setPath(toPathPoints, path)
    setPath(fromPathPoints, path)

    return path
}
